const OPTIONS_CONTENT = {
  monthly: {
    PL: {
      title: {
        type: "ComplexTitle",
        title: "Booster Pack for Private Label",
        pack: [
          {
            text: "AI Listing Builder",
            tooltip: "Build a unique listing for your product with AI using only the most popular keywords, and stand out from the competition"
          },
          {
            text: "AI Review Analyzer",
            tooltip: "Get product improvement ideas, enhance your listing, and understand why people buy the product with instant review statistics"
          },
          {
            text: "Step-by-Step Checklist for Starting a Private Label Brand",
            tooltip: "Launch your own successful private label brand on Amazon with this easy-to-follow, step-by-step checklist that covers everything from product research to listing optimization and fulfillment"
          },
          {
            text: "10-Product Report: Trends, Data, and Insights",
            tooltip: "Discover 10 top-performing Amazon products plus key trends, consumer insights, and helpful data to guide you toward informed investment decisions and spot new opportunities"
          },
          {
            text: "Private Label Suppliers List",
            tooltip: "Use this list of global and local suppliers to find reliable sources for high-quality products",
            textUS: "Private Label Suppliers List (U.S. & International)",
            tooltipUS: "Use this suppliers list that helps you find suppliers that you can source quality products from"
          }
        ]
      },
      subTitle: "+ Booster Pack for Private Label",
      payment: {
        price: 19,
        cents: 99,
        period: "/month",
        discount: 59
      }
    },
    R: {
      title: {
        type: "ComplexTitle",
        title: "Booster Pack for Reselling",
        pack: [
          {
            text: "Dropshipping, Arbitrage, and Wholesale Extension",
            tooltip: "Avoid risky products and maximize your success rate by selling branded and other existing products"
          },
          {
            text: "Step-by-Step Guide to Starting an Online Arbitrage Business",
            tooltip: "Learn how to start selling through online arbitrage on Amazon with this step-by-step guide that covers product sourcing, tools, pricing strategies, and tips for maximizing your profits"
          },
          {
            text: "List of Lower-Risk Ungated Categories",
            tooltip: "Receive a list of evergreen categories and subcategories to consider selling from if you’re just starting out on your Amazon business journey"
          },
          {
            text: "Wholesale & Online Arbitrage Suppliers List",
            tooltip: "Use these global and local suppliers to test and launch your products faster and more easily",
            textUS: "Wholesale & Online Arbitrage Suppliers List (U.S. & International)",
            tooltipUS: "Use these suppliers to test and launch your products more quickly and with simpler shipping"
          }
        ]
      },
      subTitle: "+ Booster Pack for Reselling",
      payment: {
        price: 19,
        cents: 99,
        period: "/month",
        discount: 59
      }
    }
  },
  yearly: {
    PL: {
      title: {
        type: "ComplexTitle",
        title: "Booster Pack for Private Label",
        pack: [
          {
            text: "AI Listing Builder",
            tooltip: "Build a unique listing for your product with AI using only the most popular keywords, and stand out from the competition"
          },
          {
            text: "AI Review Analyzer",
            tooltip: "Get product improvement ideas, enhance your listing, and understand why people buy the product with instant review statistics"
          },
          {
            text: "Step-by-Step Checklist for Starting a Private Label Brand",
            tooltip: "Launch your own successful private label brand on Amazon with this easy-to-follow, step-by-step checklist that covers everything from product research to listing optimization and fulfillment"
          },
          {
            text: "10-Product Report: Trends, Data, and Insights",
            tooltip: "Discover 10 top-performing Amazon products plus key trends, consumer insights, and helpful data to guide you toward informed investment decisions and spot new opportunities"
          },
          {
            text: "Private Label Suppliers List",
            tooltip: "Use this list of global and local suppliers to find reliable sources for high-quality products",
            textUS: "Private Label Suppliers List (U.S. & International)",
            tooltipUS: "Use this suppliers list that helps you find suppliers that you can source quality products from"
          }
        ]
      },
      subTitle: "+ Booster Pack for Private Label",
      payment: {
        price: 99,
        cents: 99,
        period: "/year",
        discount: 708
      }
    },
    R: {
      title: {
        type: "ComplexTitle",
        title: "Booster Pack for Reselling",
        pack: [
          {
            text: "Dropshipping, Arbitrage, and Wholesale Extension",
            tooltip: "Avoid risky products and maximize your success rate by selling branded and other existing products"
          },
          {
            text: "Step-by-Step Guide to Starting an Online Arbitrage Business",
            tooltip: "Learn how to start selling through online arbitrage on Amazon with this step-by-step guide that covers product sourcing, tools, pricing strategies, and tips for maximizing your profits"
          },
          {
            text: "List of Lower-Risk Ungated Categories",
            tooltip: "Receive a list of evergreen categories and subcategories to consider selling from if you’re just starting out on your Amazon business journey"
          },
          {
            text: "Wholesale & Online Arbitrage Suppliers List",
            tooltip: "Use these global and local suppliers to test and launch your products faster and more easily",
            textUS: "Wholesale & Online Arbitrage Suppliers List (U.S. & International)",
            tooltipUS: "Use these suppliers to test and launch your products more quickly and with simpler shipping"
          }
        ]
      },
      subTitle: "+ Booster Pack for Reselling",
      payment: {
        price: 99,
        cents: 99,
        period: "/year",
        discount: 708
      }
    }
  },
  lifetime: {}
};

export default OPTIONS_CONTENT;
